<template>
  <span class="message-file">
    <a :href="file.url" target="_blank" class="message-file__content">
      <span class="message-file__icon">
        <vs-icon
          icon-pack="feather"
          icon="icon-file"
          size="large"
        />
      </span>
      <span class="message-file__description">
        {{ file.filename }}<br>
        {{ file.size_human_readable }}
      </span>
    </a>
  </span>
</template>

<script>
export default {
  props: {
    file: {
      type: Object,
      required: true
    }
  }
}
</script>
